import { useCallback } from "react";
import { useForm, type Resolver } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { eventSchema, type EventFormData } from "@/lib/event-schemas";
import type { AdminEventDetail } from "@/lib/admin-api";
import { buildEditFormValues } from "@/lib/event-form-values";

export function useEventEditForm() {
  const form = useForm<EventFormData>({
    // TypeScript can't properly narrow discriminated unions in resolver types
    resolver: zodResolver(eventSchema) as unknown as Resolver<EventFormData>,
    defaultValues: {
      isBookable: true,
      isRecurring: false,
      rrule: "",
      imagePool: [],
      timezone: "Europe/London",
      audience: "OPEN",
      requiresConsentForm: false,
      requiresPhotoConsent: false,
      groupsEnabled: false,
      isPublished: false,
      isFeatured: false,
      isCancelled: false,
      sessions: [],
      pricePoints: [],
      bookingClosesAt: null,
      schedule: null,
      whatToBring: null,
      location: null,
      tags: [],
    },
  });

  const resetWithEvent = useCallback(
    (event: AdminEventDetail) => {
      form.reset(buildEditFormValues(event));
    },
    [form],
  );

  return {
    ...form,
    resetWithEvent,
  };
}
